import React, { memo } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { showNotifier } from "../../store/globalSlice";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={2} ref={ref} {...props} />;
});

const Notifier = () => {
  const { duration, open, message, severity } = useSelector(
    (store) => store.global.notification
  );
  const dispatch = useDispatch();

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(showNotifier());
  };

  return (
    <Snackbar
      TransitionProps={{
        exit: false,
      }}
      autoHideDuration={duration}
      open={open}
      onClose={handleClose}
    >
      <Alert variant="filled" onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default memo(Notifier);
